
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'
import Home from './pages/index';
import Refrigeration from "./pages/industrial-refrigeration"
import Coolingandchilling from "./pages/cooling-and-chilling"
import HeatPumps from "./pages/heat-pumps"
import AirPurger from "./pages/air-purger"
import Evaporative from "./pages/evaporative-condenser"
import Pressurevessels from "./pages/pressure-vessels"
import Supportservices from "./pages/support-services"
import Economizer from "./pages/economizer"
import Freezers from "./pages/freezers"
import Controlsystems from "./pages/control-systems"
import Clients from './pages/clients' 
import Contact from './pages/contact' 
import Project from './pages/project' 
// import Projectsingle from './pages/project-single' 
// import Reviews from './pages/reviews' 
import Services from './pages/services'
import Markets from './pages/markets' 
// import Pecialsrebatev2 from './pages/specials-rebate-v2' 
import Team from './pages/team' 
import About from './pages/about'
import MarketFood from './pages/market-food'
import MarketDairy from './pages/market-dairy'
import MarketHVAC from './pages/market-HVAC'
import MarketBeverage from './pages/market-beverage'
import MarketPharma from './pages/market-pharma'
import MarketOil from './pages/market-oilgaschemical'
import MarketCold from './pages/market-Cold-Storage-and-WareHouse'
import MarketPublic from './pages/market-Public-Sector-Units'
import MarketGeneralIndustries from './pages/market-General-Industries'


function Routers () {
    return (
      <Router>
           <Routes>
              <Route path="/" exact element={<Home/>}/>
              <Route element={<Refrigeration/>} exact path="/industrial-refrigeration"/>
              <Route element={<Coolingandchilling/>} exact path="/cooling-and-chilling"/>
              <Route element={<HeatPumps/>} exact path="/heat-pumps"/>
              <Route element={<AirPurger/>} exact path="/ICE-production-systems"/>
              <Route element={<Evaporative/>} exact path="/cooling-condenser"/>
              <Route element={<Pressurevessels/>} exact path="/pressure-vessels"/>
              <Route element={<Supportservices/>} exact path="/support-services"/>
               <Route element={<Economizer/>} exact path="/ammonia-recirculator-package"/>
                <Route element={<Freezers/>} exact path="/freezers"/>
                               <Route element={<Controlsystems/>} exact path="/control-systems"/>
                               <Route element={<Clients/>} exact path="/indusref-clients"/>
              {/* <Route path="/blog" exact element={<Blog/>}/> 
              <Route path="/blog-grid" exact element={<Bloggrid/>}/> 
              <Route path="/blog-single" exact element={<Blogsingle/>}/> */}
              <Route path="/contact" exact element={<Contact/>}/> 
              {/* <Route path="/faq" exact element={<Faq/>}/> 
              <Route path="/faq-single" exact element={<Faqsingle/>}/>  */}
               <Route path="/market-General-Industries" exact element={<MarketGeneralIndustries/>}/> 
              <Route path="/market-food" exact element={<MarketFood/>}/> 
              <Route path="/market-dairy" exact element={<MarketDairy/>}/>
              <Route path="/market-HVAC" exact element={<MarketHVAC/>}/>
              <Route path="/market-beverage" exact element={<MarketBeverage/>}/>
              <Route path="/market-pharma" exact element={<MarketPharma/>}/>
              <Route path="/market-oil-gas-chemical" exact element={<MarketOil/>}/>
              <Route path="/market-Cold-Storage-and-WareHouse" exact element={<MarketCold/>}/>
              <Route path="/market-Public-Sector-Units" exact element={<MarketPublic/>}/>
              <Route path="/project" exact element={<Project/>}/> 
              {/* <Route path="/project-single" exact element={<Projectsingle/>}/>  */}
              {/* <Route path="/reviews" exact element={<Reviews/>}/>  */}
              <Route path="/indusref-products"  exact element={<Services/>}/>
              <Route path="/indusref-markets" exact element={<Markets/>}/> 
              {/* <Route path="/specials-rebate-v2" exact element={<Pecialsrebatev2/>}/>  */}
              <Route path="/indusref-partners" exact element={<Team/>}/> 
              <Route path="/about-indusref" exact element={<About/>}/>
             </Routes>
       </Router>
      )
}
export default Routers;